import { createBrowserRouter } from "react-router-dom";
import ErrorPage from "../Pages/ErrorPage/ErrorPage";
import App from "../App";

import PrivateRoute from "./PrivateRoute";
import Login from "../Pages/Login/Login";
import NotAuthorised from "../Pages/NotAuthorised/NotAuthorised";
import Dashboard from "../Pages/Dashboard/Dashboard";
import ForgotPasswordMail from "../Pages/ForgotPassword/ForgotPasswordMail";
import ForgotPassword from '../Pages/ForgotPassword/ForgotPassword';
import Master from '../Pages/Master/Masters';
import Owner from '../Pages/Owner/Owner';
import Vehicle from "../Pages/Vehicle/Vehicle"
import Location from '../Pages/Location/Location';
import Designation from '../Pages/UserDesignation/Designation';
import InvalidTokenDialog from '../Components/InvalidToken/InvalidToken';
import Tariff from '../Pages/Tariff/Tariff';
import ViewLocation from '../Pages/Location/ViewLocation';
import Slot from '../Pages/Slot/Slot';
import Sales from '../Pages/Sales/Sales';
import Pricing from '../Pages/Pricing/Pricing';
import PrivacyPolicy from '../Pages/PrivacyPolicy/PrivacyPolicy';
import SpaceTypes from '../Pages/SpaceTypes/SpaceTypes';
import LocAds from '../Pages/LocAds/LocAds';
import LocAdsHistory from '../Pages/LocAds/ViewAds';
import MembershipVehicle from "../Pages/MembershipVehicle/MembershipVehicle";
import Package from "../Pages/PackageManagement/PacakageManagement";
import Subscription from "../Pages/Subscription/Supscription";
import MembershipVehicles from "../Pages/MemberhipVehicles/MembrshipVehicles";
import Users from "../Pages/Users/Users";

export const router = createBrowserRouter([
  { path: "/login", element: <Login /> },
  { path: "/forgot-password-mail", element: <ForgotPasswordMail /> },
  { path: "/forgot-password", element: <ForgotPassword /> },
  { path: "/create-password", element: <ForgotPassword /> },
  { path: "/invalid-token", element: <InvalidTokenDialog /> },
  { path: "/privacy-policy", element: <PrivacyPolicy /> },
  {
    path: "/",
    errorElement: <ErrorPage />,
    // loader:,
    element: <PrivateRoute element={<App />} />,
    children: [
      {
        path: "dashboard",
        element: <Dashboard />,
        handle: { crumb: "Dashboard" },
      },
      {
        path: "location",
        handle: { crumb: "Locations" },
        children: [
          {
            index: true,
            element: <Location />,
          },
          {
            path: "tariff/:id",
            element: <Tariff />,
            handle: { crumb: "Tariff" },
          },
          {
            path: "slot/:id",
            element: <Slot />,
            handle: { crumb: "Slots" },
          },
          {
            path: "views/:id",
            element: <ViewLocation />,
            handle: { crumb: "View" },
          },
          {
            path: "pricings/:id",
            element: <Pricing />,
            handle: { crumb: "Pricing" },
          },
          {
            path: "designations/:id",
            element: <Designation />,
            handle: { crumb: "User Designations" },
          },
          {
            path: "packageManagement/:id",
            element: <Package />,
            handle: { crumb: "Package Management" },
          },
          {
            path: "membershipVehicle/:id",
            element: <MembershipVehicle />,
            handle: { crumb: "Vehicles", dynamicCrumb: true },
          },
          {
            path: "SpaceTypes/:id",
            element: <SpaceTypes />,
            handle: { crumb: "Space Types" },
          },
          {
            path: "locAds/:id",
            element: <LocAds />,
            handle: { crumb: "Ads" },
          },
          {
            path: "locAdsHistory/:id",
            element: <LocAdsHistory />,
            handle: { crumb: "Ads History" },
          },
        ],
      },
      {
        path: "vehicle",
        element: <Vehicle />,
        handle: { crumb: "Vehicles" },
      },
      {
        path: "sales",
        element: <Sales />,
        handle: { crumb: "Sales" },
      },
      {
        path: "Subscription",
        element: <Subscription />,
        handle: { crumb: "Subscriptions" },
      },
      {
        path: "MembershipVehicles",
        element: <MembershipVehicles />,
        handle: { crumb: "Membership Vehicles" },
      },
      {
        path: "owner",
        element: <Owner />,
        handle: { crumb: "Owners" },
      },
      {
        path: "master",
        element: <Master />,
        handle: { crumb: "Masters" },
      },
      {
        path: "users",
        element: <Users />,
        handle: { crumb: "Users" },
      },

      // {
      //   path: "userPermission",
      //   element: <UserPermissions />,
      // },
      {
        path: "NotAuthorised",
        element: <NotAuthorised />,
      },
    ],
  },
]);
